import {useEffect, useState} from "react";

export function useDebouncedValue<T>(value: T, delay: number): { debouncedValue: T, isPending: boolean } {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const isPending = value !== debouncedValue;
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return { debouncedValue, isPending };
}
